import { IAlbum } from 'redhotpie-shared-lib/interfaces/IImages';
import Photo from 'redhotpie-shared-lib/models/photo';
import * as types from '../constants/actionTypes';
import * as messageUtils from '../functions/messageUtils';
import { IApiResponse } from '../interfaces/IApiResponse';
import privateAlbumService from '../services/privateAlbumService';
import * as myStore from '../store/myStore';
import { beginAjaxCall } from './ajaxStatusActions';
import * as conversationDetailAction from './conversationDetailAction';
import * as messageActions from './messageActions';
import { IPrivateAlbum } from '../interfaces/IImages';
import { is } from 'date-fns/locale';

export function getAlbumSuccess(privateAlbums: any[], friendId: string | number) {
  return { type: types.GET_ALBUM_SUCCESS, privateAlbums, friendId };
}

export function updateAlbumPermission(galleryId: number, isGranted: boolean) {
  return { type: types.UPDATE_GALLERY_ACCESS, galleryId, isGranted };
}

export function addGrantedAlbum(privateAlbums: any[], friendId: number) {
  return { type: types.ADD_GRANTED_ALBUM, privateAlbums, friendId };
}

export function getAlbumRequest() {
  return { type: types.GET_ALBUM_REQUEST };
}

export function grantAccessSuccess() {
  return { type: types.GRANT_ACCESS_SUCCESS };
}

// Get albums info & check if friendId has granted permission to view list album.
export function getAlbumInfos(friendId: string | number) {
  return (dispatch: any, getState: any) => {
    dispatch(beginAjaxCall());
    dispatch(getAlbumRequest());
    return privateAlbumService.getAlbumInfos(friendId).then((res: IApiResponse<any>) => {
      if (res.success && res.data.items?.length > 0) {
        const { profilePhotos } = getState().editProfileReducer;
        const albums: IPrivateAlbum[] = res.data.items.map((g: IAlbum) => {
          return {
            ...g,
            photos: profilePhotos.filter((p: Photo) => p.galleryId === g.galleryId).slice(-g.imageCount),
          };
        });
        dispatch(getAlbumSuccess(albums, friendId));
        return res;
      }
      dispatch(getAlbumSuccess([], friendId));
      console.log('ERROR: privateAlbumAction/getAlbumInfos', res.message);

      return res;
    });
  };
}

export function grantedAccess(galleryIds: number[], friendId: number | string, friendXmppId: string, timeValue?: number) {
  return (dispatch: any) => {
    dispatch(beginAjaxCall());
    const expiredTime = new Date().getTime() + myStore.getStore().getState().loginReducer.userInfo.messenger.defaultImageDuration.value;
    return privateAlbumService.grantedAccess(galleryIds, friendId, timeValue || expiredTime).then((res: any) => {
      // galleryIds.forEach(id => updateGalleryStatus(dispatch, id, friendXmppId, true));
      // if (res.success) {
      //   dispatch(grantAccessSuccess());
      // }
      // else {
      //   //console.log("ERROR: privateAlbumAction/grantAccess", res.message);
      // }
      return res;
    });
  };
}

function getMessageStore() {
  return myStore.getStore().getState().messageReducer;
}

function getLoginUser() {
  return myStore.getStore().getState().loginReducer.userInfo;
}

export function removeGrantedAccess(galleryIds: number[], friendId: string | number, friendXmppId: string) {
  return (dispatch: any) => {
    dispatch(beginAjaxCall());
    return privateAlbumService.removeGrantedAccess(galleryIds, friendId).then((res: any) => {
      if (res.success) {
        updateGalleryStatus(dispatch, galleryIds[0], friendXmppId, false);
      } else {
        console.log('ERROR: privateAlbumAction/grantAccess', res.message);
      }
      return res;
    });
  };
}

export function updateGalleryStatus(dispatch: any, galleryId: number, peerXmppId: string, hasAccess: boolean) {
  const galleryMessages = messageUtils.getMessagesByGalleryId(galleryId, peerXmppId, getMessageStore());
  if (galleryMessages && galleryMessages.length > 0) {
    galleryMessages.forEach((x: any) => {
      x.body.data.hasAccess = hasAccess;
      x.body.data.items = {};
      if (!hasAccess) {
        const peerVcard = {
          xmppId: getLoginUser().xmppId === x.from ? x.to : x.from,
          isGroup: false,
        };

        // update last conversation’s message in Inbox
        const messages = messageUtils.getMessagesByUser(getMessageStore(), peerVcard);
        const isLastMsg = messageUtils.isLastConversationMessage(messages, x.id);
        const previousMessage = messageUtils.getPreviousChatMessageFromId(messages, x.id);
        dispatch(conversationDetailAction.deleteMessage(x, isLastMsg, previousMessage));
      }
      dispatch(messageActions.updateGalleryStatusSuccess(x));
      dispatch(messageActions.sendMessageUpdate(x));
    });
  }
}

export function getAlbumPhotos(userId: string, galleryId: string, imageCount?: number) {
  return (dispatch: any) => {
    return privateAlbumService.getAlbumPhotos(userId, galleryId, imageCount).then((res: IApiResponse<any>) => {
      if (res.success) {
        // console.log("RES",res);
        const imagesList = res && res.data && res.data.items ? res.data.items : [];
        // dispatch(getAlbumPhotosSuccess(msgId, imagesList));
      } else {
        console.log('ERROR: MessageImage/getData', res.message);
      }
      return res;
    });
  };
}
